import React from "react";
import { Badge, BadgeColor, Grid, GridColumn, GridRow } from "sprint-common-web";

import { LanguagesDataProvider } from "../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { NoteSubjectType } from "../../../../../common/types/NoteSubjectType";
import { RecordType } from "../../../../../common/types/RecordType";
import { NotesSection } from "../../../common/notes/NotesSection";
import { isInPreparation } from "../../CloudAssetDetails";
import { useCloudAssetDetails } from "../../common/hooks/useCloudAssetDetails";
import { CloudContentSection } from "./content/CloudContentSection";
import { CloudLanguagesSection } from "./languages/CloudLanguagesSection";
import { CloudLibrarySection } from "./library/CloudLibrarySection";
import { CloudTechnicalSection } from "./technical/CloudTechnicalSection";

export const InfoSection = (): JSX.Element => {
    const { data: assetDetails } = useCloudAssetDetails();

    const noteSectionWidth = assetDetails?.type === RecordType.Subtitle ? 12 : 6;

    const isNotesFormDisabled = assetDetails && isInPreparation(assetDetails);

    return (
        <Grid>
            <GridRow>
                <GridColumn sm={7}>
                    <CloudLibrarySection />
                </GridColumn>
                <GridColumn sm={5}>
                    <CloudContentSection />
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn sm={6}>
                    <CloudTechnicalSection />
                </GridColumn>
                <GridColumn sm={noteSectionWidth}>
                    <NotesSection
                        subjectType={NoteSubjectType.CloudAsset}
                        isFormDisabled={isNotesFormDisabled}
                        renderBadge={() => (
                            <Badge
                                text="Cloud"
                                color={BadgeColor.LightGreen}
                                size={12}
                                testId="note-cloud-badge"
                                tooltipContent="Cloud asset note"
                            />
                        )}
                    />
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn sm={12}>
                    <LanguagesDataProvider>
                        <CloudLanguagesSection />
                    </LanguagesDataProvider>
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
